// logged-in.match.ts
import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { AuthServerProvider } from 'src/app/core/auth/auth-jwt.service';

@Injectable({ providedIn: 'root' })
export class LoggedInMatch implements CanMatch {
  constructor(private auth: AuthServerProvider) {}
  canMatch(_route: Route, _segments: UrlSegment[]) {
    return this.auth.isAuthenticated(); // true → this route matches
  }
}
